// Research provenance: schools contain sources. Served by GET /api/sources,
// already grouped by school (conventional / integrative / partner schools).
export type Source = { id: string; label: string; description: string; school: string };
export type SourcesResponse = { sources: Record<string, Source[]> };

export function schoolList(resp: SourcesResponse | undefined): { school: string; sources: Source[] }[] {
  if (!resp) return [];
  return Object.entries(resp.sources)
    .map(([school, sources]) => ({ school, sources }))
    .sort((a, b) => a.school.localeCompare(b.school));
}
